import * as React from "react";
import { TextField } from "@fluentui/react/lib/TextField";
import { NumberProps } from "../../interfaces/props/NumberProps";

// import * as lcid from "lcid";
import { localStringToNumber } from "../helpers/stringHelper";
import * as lcid from "../../../../utilities/lcid/lcid";
import { logger } from "../../../../utilities/logger";
import { inputResult } from "../helpers/inputResult";
import { decimalSteps } from "../../config/constants";
import { SharePointMetadataBooleans } from "../../config/sharepointConstants";

export const Percentage: React.FunctionComponent<NumberProps> = ({
  displayName,
  isRequired,
  inputValue,
  min,
  max,
  updateInputValidationStatus,
  inputValidator,
  error,
  regionalSetting,
  decimals
}: NumberProps) => {
  const [numberFormatter] = React.useState<Intl.NumberFormat>(new Intl.NumberFormat(lcid.from(regionalSetting?.CollationLCID).replace("_", "-"), { maximumFractionDigits: decimals ?? 2 }));
  const [isInFocus, setIsInFocus] = React.useState<boolean>(false);
  const [formattedNumberValue, setFormattedNumberValue] = React.useState<string>(!isNaN(Number(inputValue?.value ?? undefined)) ? (inputValue?.value * 100).toString() : null);
  const [numericInputError, setNumericInputError] = React.useState<string>();

  const isFirstRun = React.useRef(true);

  React.useEffect(() => {
    try {
      setFormattedNumberValue(inputValue?.value);
    } catch (e) {
      logger(e, "percentage.tsx (useEffect(inputValue?.value))")
    }
  }, [inputValue?.value]);

  React.useEffect(() => {
    try {
      if (isFirstRun.current) {
        isFirstRun.current = false;
        return;
      }
      updateInputValidationStatus(inputValidator.validate(inputValue?.value));
    } catch (e) {
      logger(e, "percentage.tsx (useEffect)")
    }
  }, [inputValue?.updatedFromDataSourceToggle]);

  const onChangeNumberField = (event: any, value?: string) => {
    const validationResult: inputResult = inputValidator.validate(value);
    if (value) {
      setNumericInputError(validationResult?.error);
    }
    updateInputValidationStatus(validationResult);
  };

  const onChangeTextField = React.useCallback((event: any, value?: string) => {
    return;
  }, []);

  const onBlur = (event: any): void => {
    const validationResult: inputResult = inputValidator.validate(event.target.value);
    setNumericInputError(validationResult?.error);
    updateInputValidationStatus(validationResult);
    if (event.target.value) {
      const numberValue = localStringToNumber(event.target.value);
      setFormattedNumberValue(numberFormatter.format(numberValue));
    }
    else {
      setFormattedNumberValue(null);
    }
    setIsInFocus(false);
  };

  const onFocus = (event: any): void => {
    setIsInFocus(true);
  };

  const percentageInputField = (
    <TextField
      label={displayName + " %"}
      disabled={inputValue?.xml?.ReadOnly === SharePointMetadataBooleans.true}
      type="number"
      step={decimals !== undefined ? decimalSteps[decimals] : decimalSteps[2]}
      min={min !== undefined ? (min * 100) : ""}
      max={max !== undefined ? (max * 100) : ""}
      onBlur={onBlur}
      value={inputValue?.value ?? ""}
      onChange={onChangeNumberField}
      required={isRequired()}
      errorMessage={numericInputError}
      className="xb-sp-input"
    />
  );

  const textInputField = (
    <TextField
      label={displayName + " %"}
      disabled={inputValue?.xml?.ReadOnly === SharePointMetadataBooleans.true}
      type="text"
      value={formattedNumberValue ?? ""}
      onChange={onChangeTextField}
      onFocus={onFocus}
      required={isRequired()}
      errorMessage={error}
      className="xb-sp-input"
    />
  );

  return isInFocus ? percentageInputField : textInputField;
};

export default Percentage;
